import React from "react";
import Checkbox from "@mui/material/Checkbox";
import { useDispatch } from "react-redux";
import { InvoiceFilterAction } from "../../Redux/actions/filterActions";
import classes from "./filters.module.css";

/**
 * Active/Inactive (or Delivered/Not Delivered) status filter for the drawer.
 * Replaces the inline `InvoiceFilter`. Selection is the boolean array held in
 * `state.filter.invoice`; the backend matches it via `is_active: { $in: [...] }`.
 *
 * Props:
 *  - label: section title (defaults to "Status")
 *  - selected: boolean[] from state.filter.invoice
 *  - communication: when true, labels read "Delivered"/"Not Delivered"
 */
const StatusFilter = ({ label = "Status", selected = [], communication = false }) => {
  const dispatch = useDispatch();
  const current = selected || [];

  const toggle = (value) => {
    const next = current.includes(value)
      ? current.filter((v) => v !== value)
      : [...current, value];
    dispatch(InvoiceFilterAction(next));
  };

  const options = [
    { value: true, label: communication ? "Delivered" : "Active" },
    { value: false, label: communication ? "Not Delivered" : "Inactive" },
  ];

  return (
    <div className={classes.section}>
      <span className={classes.sectionLabel}>{label}</span>
      <div className={classes.optionList}>
        {options.map((opt) => (
          <label key={String(opt.value)} className={classes.optionRow}>
            <Checkbox
              size="small"
              checked={current.includes(opt.value)}
              onChange={() => toggle(opt.value)}
            />
            {opt.label}
          </label>
        ))}
      </div>
    </div>
  );
};

export default StatusFilter;
